import { Section } from '@shared/components/Section';
import { curso } from '@curso/content/curso';
import { GradeDeCompetencias } from '@shared/components/moldes';
import { BotaoDeContato } from '@inscricao/components/Contato';
import { ferramentas, camadas, daFerramentaAoComportamento } from '@curso/content/ferramentas';

/**
 * Responde: o que muda na segunda-feira.
 *
 * Ferramenta com nome converte melhor que competência abstrata. Foi o que os
 * dois documentos do briefing apontaram, e é o bloco onde cada leitor decide
 * se o curso é para ele.
 */
export function OQueVoceLeva() {
  return (
    <Section
      id="o-que-leva"
      rotulo="O que você leva"
      titulo="Ferramentas para aplicar na prática"
    >
      <p className="prosa">
        Da comunicação à implementação: ferramentas e estratégias para ajudar equipes a se
        comunicar, liderar, antecipar riscos, apoiar umas às outras, responder ao inesperado e
        transformar aprendizado em prática.
      </p>
      <p className="prosa mt-3">
        Ao longo da {curso.formato}, conceitos de fatores humanos são traduzidos em
        comportamentos e ferramentas aplicáveis ao cotidiano das equipes de saúde.
      </p>

      <div className="mt-8">
        <GradeDeCompetencias itens={ferramentas} />
      </div>

      {/* As duas camadas: sem foto, para lerem como continuação e não como competência. */}
      <ul className="mt-10 grid gap-x-8 gap-y-8 border-t border-linha-forte pt-8 sm:grid-cols-2">
        {camadas.map((camada) => (
          <li key={camada.competencia}>
            <h3 className="display-item">{camada.competencia}</h3>
            <p className="mt-1 text-apoio font-medium text-tinta">{camada.subtitulo}</p>
            <p className="mt-1.5 text-apoio leading-relaxed text-pretty text-tinta-suave">
              {camada.texto}
            </p>
            <ul className="mt-3 flex flex-wrap gap-2">
              {camada.ferramentas.map((ferramenta) => (
                <li
                  key={ferramenta}
                  className="border border-linha-forte px-2.5 py-1 text-miudo"
                >
                  {ferramenta}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>

      <div className="mt-12 border-t border-linha-forte pt-8">
        <h3 className="display-item">{daFerramentaAoComportamento.titulo}</h3>
        <p className="prosa mt-3">{daFerramentaAoComportamento.texto}</p>
        <p className="prosa mt-4 text-tinta">{daFerramentaAoComportamento.remate}</p>
      </div>

      <div className="mt-8 border-t border-linha pt-7">
        <BotaoDeContato origem="o-que-leva" />
      </div>
    </Section>
  );
}
